
namespace RecordShield.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class QueuedEmailDialog extends Serenity.EntityDialog<QueuedEmailRow, any> {
        protected getFormKey() { return QueuedEmailForm.formKey; }
        protected getIdProperty() { return QueuedEmailRow.idProperty; }
        protected getLocalTextPrefix() { return QueuedEmailRow.localTextPrefix; }
        protected getNameProperty() { return QueuedEmailRow.nameProperty; }
        protected getService() { return QueuedEmailService.baseUrl; }

        protected form = new QueuedEmailForm(this.idPrefix);

        loadEntity(entity: AuditLogRow) {
            super.loadEntity(entity);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(0, 3);

            return buttons;
        }

    }
}